import { Component, OnInit, Input, EventEmitter, ViewEncapsulation, Output } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { SubscriptionCardModel } from './subscription-card.model';
@Component({
  selector: 'app-subscription-card',
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionCardComponent implements OnInit {
  @Input() subscripitioncard: SubscriptionCardModel;
  @Output() skuId: EventEmitter<String>;
  @Output() pageLoaderEvent: EventEmitter<boolean>;
  shopPermission: string;

  constructor() {
    this.skuId = new EventEmitter<String>();
    this.pageLoaderEvent = new EventEmitter<boolean>();
    this.shopPermission = 'detail.shopmanage';
  }

  ngOnInit() {
    this.shopPermission = 'detail.shopmanage';
    this.pageLoaderEvent.emit(true);
  }

  shopNow(id: string) {
    this.skuId.emit(id);
  }

}
